export const experiences = [
  {
    _id: "630120134042e2d798b59dc2",
    company: "SIH",
    title: "Smart India Hackathon",
    period: "September 2023",
    description:
      "Developed an innovative application designed to monitor the Air Quality Index (AQI) and Water Quality Index (WQI) across multiple locations throughout India. The system provides users with environmental quality metrics for various regions, supporting proactive public health decisions. It uses advanced geospatial analysis and visualization for easy monitoring and insights.",
    projectLink: "https://github.com/chandu-bala/EnviroMonitor",
  },
  {
    _id: "630120134042e2d798b59dc1",
    company: "C-DAC",
    title: "Secure Webserver deployment and access control",
    period: "October 2023",
    description:
      "The project deploys a secure web server in OpenStack, leveraging its security features to manage user permissions and protect resources. It blocks ICMP (ping) requests, allows HTTP traffic, enables remote control via SSH, and secures web traffic with SSL/TLS.",
    projectLink: "https://github.com/chandu-bala",
  },
  {
    _id: "630120134042e2d798b59dc0",
    company: "HCL",
    title: "OnWheels Centralized Management System",
    period: "April 2024",
    description:
      "Created a robust vehicle management application with features such as maintenance scheduling, live GPS tracking, and user-friendly interactions. Integrated multiple functionalities to improve vehicle tracking and management efficiency.",
    projectLink: "https://github.com/chandu-bala/VEHICLE_MNGT",
  },
  {
    _id: "630120134042e2d798b59dc3",
    company: "JPMorgan Chase & Co",
    title: "CODE FOR <GOOD>",
    period: "July 2024",
    description:
      "Developed an innovative application for the Shola Trust that leverages machine learning and computer vision to identify and map potential sites of the invasive weed Lantana Camara. The application analyzes images captured by field agents to detect and categorize Lantana Camara growth in targeted areas. This solution aids in efficient monitoring and management of the invasive species, supporting conservation efforts.",
    projectLink: "https://github.com/cfgbengaluru24/Team-27",
  },
  {
    _id: "630120134042e2d798b59dc4",
    company: "Code Vipassana & Project Sadhana",
    title: "NovaMind-AI",
    period: "November 2025",
    description:
      "NovaMind-AI is an intelligent AI-driven mentorship platform designed to guide students, developers, and innovators across the complete lifecycle of idea execution — from raw concept to deployable project and career advancement. Built as part of the Code Vipassana & Project Sadhana Marathon, the platform focuses on practical AI application in real-world learning, cloud-native architecture, and scalable mentorship automation.",
    projectLink: "https://github.com/chandu-bala/NovaMind-AI",
  },
];
